import React from 'react';
import PropTypes from 'prop-types';
import { useCollectionStateContext } from 'Context/CollectionStateContext';

const AuthenticationFactorListContext = React.createContext(undefined);

export const AuthenticationFactorListProvider = ({
  children,
}) => {
  const { refreshCollection } = useCollectionStateContext();
  const [modalLink, setModalLink] = React.useState(null);

  return (
    <AuthenticationFactorListContext.Provider
      value={{
        modalLink,
        setModalLink: (link) => setModalLink(link),
        clearModalLink: () => setModalLink(null),
        refreshListCollection: refreshCollection,
      }}
    >
      {children}
    </AuthenticationFactorListContext.Provider>
  );
};

export const useAuthenticationFactorListContext = () => {
  const context = React.useContext(AuthenticationFactorListContext);
  if (context === undefined) {
    throw new Error('useAuthenticationFactorListContext must be used within a provider');
  }
  return context;
};

AuthenticationFactorListProvider.defaultProps = {
};

AuthenticationFactorListProvider.propTypes = {
  children: PropTypes.any.isRequired,
};
